<template>
    <modal ref="modal">
        <template slot="title">Edit Contact</template>
        <div v-if="form">
            <div class="row">
                <div class="col">
                    <input-text
                        label="Name"
                        v-model="form.name"
                        :form="form"
                        field="name"
                    />
                </div>
                <div class="col">
                    <input-text
                        label="Phone Number"
                        v-model="form.phone_number"
                        :form="form"
                        field="phone_number"
                    />
                </div>
            </div>
            <input-text
                label="Email"
                v-model="form.email"
                :form="form"
                field="email"
            />

            <div class="form-group">
                <label>Location(s)</label>

                <multiselect
                    placeholder="Search or add a location"
                    track-by="id"
                    label="name"
                    :multiple="true"
                    :taggable="true"
                    :loading="loadingLocations"
                    v-model="form.locations"
                    :options="locations"
                    @input="updateGroups"
                    :max="teamConfig.single_contact_per_location ? 1 : 99999"
                >
                    <span v-if="teamConfig.single_contact_per_location" slot="maxElements">Only one location can be selected</span>
                </multiselect>

                <p class="invalid-feedback" v-if="!form.locations.length &amp;&amp; form.errors.has('locations')">
                    {{ form.errors.get('locations') }}
                </p>
            </div>

            <div class="form-group">
                <label>Group(s)</label>

                <multiselect
                    v-model="form.groups"
                    placeholder="Search or add a group"
                    track-by="id"
                    label="name"
                    :options="groups"
                    :multiple="true"
                />

                <p class="invalid-feedback" v-if="!form.groups.length &amp;&amp; form.errors.has('groups')">
                    {{ form.errors.get('groups') }}
                </p>
            </div>
        </div>
        <div slot="footer" v-if="form">
            <button-loading
                class="btn btn-primary ml-1"
                type="button"
                @click="save"
                :loading="form.submitting">
                Save changes
            </button-loading>
        </div>
    </modal>
</template>

<script>
    export default {
        props: ['contact'],

        data() {
            return {
                loadingLocations: true,
                loadingGroups   : true,
                form            : new Form(),
                locations       : [],
                groups          : [],
                teamConfig      : {},
            }
        },

        watch: {
            contact: {
                immediate: true,
                handler() {
                    this.form = new Form({
                        name        : this.contact.name         || null,
                        phone_number: this.contact.phone_number || null,
                        email       : this.contact.email        || null,
                        team_id     : this.contact.team_id      || null,
                        id          : this.contact.id           || null,
                        locations   : this.contact.locations    || [],
                        groups      : this.contact.groups       || [],
                        tags        : this.contact.tags         || []
                    });
                }
            }
        },

        methods: {
            open() {
                this.fetchTeamConfig();
                this.fetchLocations();
                this.fetchGroups();

                this.$refs.modal.open();
            },

            close() {
                this.$emit('saved');
                this.$refs.modal.close();
            },

            save() {
                this.form.put(this.$laroute.route('api.contacts.update', {contact: this.form.id}))
                    .then(() => this.close())
            },

            fetchLocations() {
                return this.$http.get(this.$laroute.route('api.global-filters.location', {'hide': 'campaigns'}))
                    .then(({data}) => {
                        this.locations = data.data;
                        this.loadingLocations = false;
                    });
            },

            fetchGroups() {
                return this.$http.get('/groups-list')
                    .then((response) => {
                        this.groups = response.data;
                        this.loadingGroups = false;
                    });
            },

            updateGroups() {
                let params = {locations : this.form.locations.map(location => location.id)};
                return this.$http.get('/groups-list',{params})
                    .then((response) => {
                        this.groups = response.data;
                    });
            },

            async fetchTeamConfig() {
                const { data } = await this.$http.get(this.$laroute.route('api.teams.current-team-config'));
                this.teamConfig = data.data;
            },
        },
    }
</script>
